module.exports = __webpack_public_path__ + "files/f8438c9747cdb6c1da727ba0736686d0.png";